import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "row gy-5 g-xl-10" }
const _hoisted_2 = { class: "mb-5 mb-xl-10 col-xl-12" }
const _hoisted_3 = { class: "row g-5 g-xl-10 h-xxl-50 mb-0 mb-xl-10" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header pt-5" }
const _hoisted_6 = { class: "card-title align-items-center" }
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = { class: "card-toolbar" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "svg-icon svg-icon-2" }
const _hoisted_14 = {
  class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold",
  role: "tablist"
}
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = {
  class: "nav",
  role: "tablist"
}
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "card-body pb-0" }
const _hoisted_21 = { class: "tab-content overflow-auto" }
const _hoisted_22 = { class: "table align-middle table-row-bordered gy-5 fs-6 mb-0" }
const _hoisted_23 = { class: "text-start text-gray-400 fw-bold text-uppercase gs-0" }
const _hoisted_24 = { class: "text-start" }
const _hoisted_25 = { class: "text-start" }
const _hoisted_26 = { class: "text-end" }
const _hoisted_27 = { class: "text-end" }
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { class: "fw-bold text-gray-800" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_33 = { class: "d-flex el-input el-input-group" }
const _hoisted_34 = { class: "svg-icon svg-icon-4 svg-icon-gray-600 ms-1" }
const _hoisted_35 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_36 = { class: "svg-icon svg-icon-4 svg-icon-gray-600 ms-1" }
const _hoisted_37 = { class: "text-end text-nowrap" }
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = { class: "d-flex el-input el-input-group--append el-input--suffix" }
const _hoisted_40 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_41 = {
  key: 0,
  class: "text-end"
}
const _hoisted_42 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_43 = { class: "el-input-group__append d-flex w-auto flex-center px-0" }
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = { class: "text-end text-nowrap" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "svg-icon svg-icon-3" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "svg-icon svg-icon-3" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { colspan: "8" }
const _hoisted_52 = {
  key: 0,
  class: "d-flex flex-column text-primary fs-7 max-sm-gap-4"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = {
  key: 1,
  class: "mx-2"
}
const _hoisted_57 = { key: 2 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = {
  key: 1,
  class: "d-flex flex-column text-primary fs-7"
}
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = {
  key: 1,
  class: "mx-2"
}
const _hoisted_65 = { key: 2 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = ["colspan"]
const _hoisted_68 = { class: "d-flex flex-column gap-2" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-md-12" }
const _hoisted_71 = { class: "form-group d-flex flex-wrap max-sm-flex-column max-sm-mb-0" }
const _hoisted_72 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_73 = { class: "col-md-12" }
const _hoisted_74 = { class: "form-group d-flex flex-wrap max-sm-flex-column max-sm-mb-0" }
const _hoisted_75 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_76 = { class: "d-flex flex-column gap-2" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-md-12" }
const _hoisted_79 = { class: "form-group d-flex flex-wrap max-sm-flex-column max-sm-mb-0" }
const _hoisted_80 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_81 = { class: "el-form-item__content max-sm-w-100" }
const _hoisted_82 = { class: "mw-300px max-sm-mw-380px d-flex flex-wrap" }
const _hoisted_83 = { class: "col-md-12" }
const _hoisted_84 = { class: "form-group d-flex flex-wrap max-sm-flex-column max-sm-mb-0" }
const _hoisted_85 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_86 = { class: "el-form-item__content max-sm-w-100" }
const _hoisted_87 = { class: "mw-300px max-sm-mw-380px d-flex flex-wrap" }
const _hoisted_88 = {
  colspan: "2",
  class: "text-end align-baseline"
}
const _hoisted_89 = { class: "d-flex flex-column gap-6" }
const _hoisted_90 = { class: "pt-3 text-nowrap" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { key: 1 }
const _hoisted_93 = { class: "fs-4 fw-bold" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("td", { colspan: "1" }, null, -1)
const _hoisted_95 = { class: "text-end text-nowrap align-baseline" }
const _hoisted_96 = { class: "d-flex flex-column gap-6" }
const _hoisted_97 = { class: "pt-3" }
const _hoisted_98 = {
  key: 0,
  class: "d-flex align-items-center justify-content-end"
}
const _hoisted_99 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_update_shipping_fee",
  class: "svg-icon svg-icon-3 ms-2 me-0 cursor-pointer"
}
const _hoisted_100 = {
  key: 1,
  class: "d-flex align-items-center justify-content-end"
}
const _hoisted_101 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_update_shipping_fee",
  class: "svg-icon svg-icon-3 ms-2 me-0 cursor-pointer"
}
const _hoisted_102 = { class: "fs-4 fw-bold" }
const _hoisted_103 = { class: "table align-middle table-row-dashed gy-5 mb-0" }
const _hoisted_104 = { class: "text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_105 = { class: "text-start" }
const _hoisted_106 = { class: "text-start" }
const _hoisted_107 = { class: "text-end" }
const _hoisted_108 = { class: "text-end text-uppercase" }
const _hoisted_109 = { class: "text-end text-uppercase" }
const _hoisted_110 = { class: "text-end text-uppercase" }
const _hoisted_111 = { class: "fw-bold text-gray-800" }
const _hoisted_112 = { class: "text-end w-100px" }
const _hoisted_113 = { class: "text-end" }
const _hoisted_114 = { class: "text-end" }
const _hoisted_115 = { class: "text-end" }
const _hoisted_116 = {
  key: 0,
  class: "card-footer d-flex flex-column py-6 px-9 gap-5"
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_118 = { class: "svg-icon svg-icon-3" }
const _hoisted_119 = ["disabled"]
const _hoisted_120 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_121 = { class: "svg-icon svg-icon-3" }
const _hoisted_122 = ["disabled"]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_124 = { class: "svg-icon svg-icon-3" }
const _hoisted_125 = ["disabled"]
const _hoisted_126 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_127 = { class: "svg-icon svg-icon-3" }
const _hoisted_128 = ["disabled"]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_130 = { class: "svg-icon svg-icon-3" }
const _hoisted_131 = ["disabled"]
const _hoisted_132 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_133 = { class: "svg-icon svg-icon-3" }
const _hoisted_134 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9 gap-2"
}
const _hoisted_135 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_136 = { class: "svg-icon svg-icon-3" }
const _hoisted_137 = ["disabled"]
const _hoisted_138 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_139 = { class: "svg-icon svg-icon-3" }
const _hoisted_140 = ["disabled"]
const _hoisted_141 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_142 = { class: "svg-icon svg-icon-3" }
const _hoisted_143 = ["disabled"]
const _hoisted_144 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_145 = { class: "svg-icon svg-icon-3" }
const _hoisted_146 = ["disabled"]
const _hoisted_147 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_148 = { class: "svg-icon svg-icon-3" }
const _hoisted_149 = ["disabled"]
const _hoisted_150 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_151 = { class: "svg-icon svg-icon-3" }
const _hoisted_152 = { class: "col-xxl-4" }
const _hoisted_153 = { class: "card card-flush mb-5" }
const _hoisted_154 = { class: "card-header pt-7" }
const _hoisted_155 = { class: "card-title align-items-start flex-column flex-fill" }
const _hoisted_156 = {
  key: 0,
  class: "text-gray-400 mt-1 fw-semibold fs-6"
}
const _hoisted_157 = { class: "card-toolbar" }
const _hoisted_158 = { class: "svg-icon svg-icon-2" }
const _hoisted_159 = { class: "card-body" }
const _hoisted_160 = { class: "d-flex align-items-sm-center mb-5" }
const _hoisted_161 = {
  key: 0,
  class: "symbol symbol-45px me-4"
}
const _hoisted_162 = { class: "symbol-label" }
const _hoisted_163 = { class: "d-flex align-items-center flex-row-fluid flex-wrap" }
const _hoisted_164 = { class: "flex-grow-1 me-2" }
const _hoisted_165 = { class: "text-gray-400 fs-6 fw-semibold" }
const _hoisted_166 = { class: "text-gray-800 fw-bold d-block fs-4" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_168 = { class: "overflow-auto d-flex gap-4 py-6" }
const _hoisted_169 = { class: "symbol-label bg-lighten" }
const _hoisted_170 = { class: "symbol-badge badge badge-circle bg-primary top-100 start-100" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-4" }, null, -1)
const _hoisted_172 = { class: "timeline" }
const _hoisted_173 = { class: "timeline-item align-items-center mb-7" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px mt-6 mb-n12" }, null, -1)
const _hoisted_175 = {
  class: "timeline-icon",
  style: {"margin-left":"11px"}
}
const _hoisted_176 = { class: "svg-icon svg-icon-2 svg-icon-danger" }
const _hoisted_177 = { class: "timeline-content m-0" }
const _hoisted_178 = { class: "fs-6 text-gray-400 fw-semibold d-block" }
const _hoisted_179 = { class: "fs-6 fw-bold text-gray-800" }
const _hoisted_180 = { class: "timeline-item align-items-center" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_182 = {
  class: "timeline-icon",
  style: {"margin-left":"11px"}
}
const _hoisted_183 = { class: "svg-icon svg-icon-2 svg-icon-info" }
const _hoisted_184 = { class: "timeline-content m-0" }
const _hoisted_185 = { class: "fs-6 text-gray-400 fw-semibold d-block" }
const _hoisted_186 = { class: "fs-6 fw-bold text-gray-800" }
const _hoisted_187 = {
  key: 0,
  class: "separator separator-dashed mb-4 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_common_product = _resolveComponent("common-product")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_relation_fulfillment = _resolveComponent("relation-fulfillment")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _component_confirm_product_modal = _resolveComponent("confirm-product-modal")!
  const _component_update_shipping_fee = _resolveComponent("update-shipping-fee")!
  const _component_UpdateProduct = _resolveComponent("UpdateProduct")!
  const _component_UpdateProductNotes = _resolveComponent("UpdateProductNotes")!
  const _component_update_product_not_date = _resolveComponent("update-product-not-date")!
  const _component_print_preview = _resolveComponent("print-preview")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      rules: _ctx.rules,
      model: _ctx.formData,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass({
              'col-xxl-12': _ctx.options.isEdit,
              'col-xxl-8': !_ctx.options.isEdit,
            })
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRequest.orderItems")), 1),
                      (
                      _ctx.formData.order_progress < _ctx.OrderRequestProgress.Rejected &&
                      !_ctx.options.isEdit &&
                      !_ctx.isAuditView
                    )
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "svg-icon svg-icon-3 ms-2 cursor-pointer",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeEdit && _ctx.changeEdit(...args)))
                          }, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-light-primary",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#modal_update_product",
                          disabled: 
                        _ctx.loading ||
                        _ctx.formData.merchant === 0 ||
                        _ctx.formData.invoice_address === 0
                      
                        }, [
                          _createElementVNode("span", _hoisted_10, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.addItem")), 1)
                        ], 8, _hoisted_9)
                      ])
                    ], 512), [
                      [_vShow, _ctx.options.isEdit && _ctx.options.isAdd]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_11, [
                      (_ctx.isCanPrint)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-sm btn-primary me-3 max-sm-hidden",
                            disabled: _ctx.loading,
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getPrintedSheetAll && _ctx.getPrintedSheetAll(...args)))
                          }, [
                            _createElementVNode("span", null, [
                              _createElementVNode("span", _hoisted_13, [
                                _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/prints.svg" })
                              ]),
                              _createTextVNode(" " + _toDisplayString(_ctx.t("common.printAll")), 1)
                            ])
                          ], 8, _hoisted_12))
                        : _createCommentVNode("", true),
                      _createVNode(_component_window_resize, null, {
                        sm: _withCtx(() => [
                          _createElementVNode("ul", _hoisted_14, [
                            _createElementVNode("li", _hoisted_15, [
                              _createElementVNode("a", {
                                class: _normalizeClass(["nav-link text-active-primary fw-bold px-4 me-1", {
                              active: _ctx.options.tabIndex === 0,
                            }]),
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateTab(0)))
                              }, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsDetails")), 3)
                            ]),
                            _createElementVNode("li", _hoisted_16, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["nav-link text-active-primary fw-bold px-4 me-1", {
                              active: _ctx.options.tabIndex === 1,
                            }]),
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateTab(1)))
                              }, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsProgress")), 3)
                            ])
                          ])
                        ]),
                        lg: _withCtx(() => [
                          _createElementVNode("ul", _hoisted_17, [
                            _createElementVNode("li", _hoisted_18, [
                              _createElementVNode("a", {
                                class: _normalizeClass(["nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1", {
                              active: _ctx.options.tabIndex === 0,
                            }]),
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateTab(0)))
                              }, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsDetails")), 3)
                            ]),
                            _createElementVNode("li", _hoisted_19, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1", {
                              active: _ctx.options.tabIndex === 1,
                            }]),
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateTab(1)))
                              }, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsProgress")), 3)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ], 512), [
                      [_vShow, !_ctx.options.isEdit]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane blockui", {
                      active: _ctx.options.tabIndex === 0,
                    }])
                      }, [
                        _createElementVNode("table", _hoisted_22, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_23, [
                              _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.t("order.product")), 1),
                              _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.t("order.sku")), 1),
                              _withDirectives(_createElementVNode("th", { class: "text-end" }, _toDisplayString(_ctx.t("orderRequest.qtyReq")), 513), [
                                [_vShow, !_ctx.options.isAdd && _ctx.options.isEdit]
                              ]),
                              _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.t("orderRequest.qtyConf")), 1),
                              _createElementVNode("th", _hoisted_27, [
                                _createTextVNode(_toDisplayString(_ctx.options.isTaxCount
                                ? _ctx.t("orderRequest.grossPrice")
                                : _ctx.t("orderRequest.netPrice")) + " ", 1),
                                _withDirectives(_createElementVNode("span", {
                                  class: "svg-icon svg-icon-3 ms-2 me-0 cursor-pointer",
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeTax && _ctx.changeTax(...args)))
                                }, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr032.svg" })
                                ], 512), [
                                  [_vShow, _ctx.options.isEdit]
                                ])
                              ]),
                              _createElementVNode("th", _hoisted_28, [
                                _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.t("order.discount")), 513), [
                                  [_vShow, !_ctx.isDoubleSale && !_ctx.isAuditView]
                                ])
                              ]),
                              _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.t("order.tax")), 1),
                              _createElementVNode("th", {
                                class: _normalizeClass(["text-end", {
                              'pe-0': !_ctx.options.isAdd,
                            }])
                              }, _toDisplayString(_ctx.t("orderRequest.listTotal")), 3),
                              _withDirectives(_createElementVNode("th", { class: "text-end" }, _toDisplayString(_ctx.t("common.action")), 513), [
                                [_vShow, _ctx.options.isAdd || _ctx.isCanPrint]
                              ])
                            ])
                          ]),
                          _createElementVNode("tbody", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.relation_items, (item, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                _createElementVNode("tr", {
                                  class: _normalizeClass({
                              'border-0': _ctx.isShowItemDescription(item),
                            })
                                }, [
                                  _createVNode(_component_common_product, {
                                    gallery: [
                                {
                                  id: 0,
                                  origin_url: item.__show.product_gallery,
                                },
                              ],
                                    brand_id: item.brand_name,
                                    brand_article_no: item.article_no,
                                    product_identifier_id: 
                                item.__show.product_identifier_id
                              ,
                                    source_link: '',
                                    name: item.__show.product_name,
                                    name_en: item.__show.product_name,
                                    color: item.color,
                                    size: item.size
                                  }, null, 8, ["gallery", "brand_id", "brand_article_no", "product_identifier_id", "name", "name_en", "color", "size"]),
                                  _withDirectives(_createElementVNode("td", { class: "text-end" }, _toDisplayString(item.request_qty), 513), [
                                    [_vShow, !_ctx.options.isAdd && _ctx.options.isEdit]
                                  ]),
                                  _createElementVNode("td", _hoisted_31, [
                                    _withDirectives(_createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_32, [
                                        _withDirectives(_createVNode(_component_el_form_item, {
                                          class: "m-0",
                                          prop: 
                                      'relation_items.' +
                                      index +
                                      '.confirmed_qty'
                                    
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              class: "w-70px size-sm",
                                              modelValue: item.confirmed_qty,
                                              "onUpdate:modelValue": ($event: any) => ((item.confirmed_qty) = $event),
                                              placeholder: " "
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_option, {
                                                  label: '',
                                                  value: ''
                                                }),
                                                (item.shipped_qty === 0)
                                                  ? (_openBlock(), _createBlock(_component_el_option, {
                                                      key: 0,
                                                      label: 0,
                                                      value: 0
                                                    }))
                                                  : _createCommentVNode("", true),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.request_qty, (row, rowIndex) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: rowIndex,
                                                    label: row,
                                                    value: row,
                                                    disabled: 
                                            row < item.shipped_qty ||
                                            row < item.invoiced_qty
                                          
                                                  }, null, 8, ["label", "value", "disabled"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1032, ["prop"]), [
                                          [_vShow, _ctx.options.isEdit && !_ctx.options.isAdd]
                                        ]),
                                        _withDirectives(_createVNode(_component_el_form_item, {
                                          class: "m-0",
                                          prop: 
                                      'relation_items.' + index + '.request_qty'
                                    
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_33, [
                                              _createVNode(_component_el_input_number, {
                                                class: "w-90px size-sm text-end",
                                                modelValue: item.request_qty,
                                                "onUpdate:modelValue": ($event: any) => ((item.request_qty) = $event),
                                                precision: 0,
                                                step: 1,
                                                min: 0,
                                                controls: false
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["prop"]), [
                                          [_vShow, _ctx.options.isAdd]
                                        ]),
                                        (item.relation_fulfillment)
                                          ? (_openBlock(), _createBlock(_component_el_popover, {
                                              key: 0,
                                              placement: "top",
                                              width: "auto",
                                              trigger: "click"
                                            }, {
                                              reference: _withCtx(() => [
                                                _withDirectives(_createElementVNode("span", _hoisted_34, [
                                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                                ], 512), [
                                                  [_vShow, 0]
                                                ])
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_relation_fulfillment, {
                                                  items: item.relation_fulfillment
                                                }, null, 8, ["items"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 512), [
                                      [_vShow, _ctx.options.isEdit]
                                    ]),
                                    _withDirectives(_createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("span", null, _toDisplayString(item.confirmed_qty), 1),
                                        (
                                      item.relation_fulfillment && !_ctx.isDoubleSale
                                    )
                                          ? (_openBlock(), _createBlock(_component_el_popover, {
                                              key: 0,
                                              placement: "top",
                                              width: "auto",
                                              trigger: "click"
                                            }, {
                                              reference: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_36, [
                                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                                ])
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_relation_fulfillment, {
                                                  items: item.relation_fulfillment
                                                }, null, 8, ["items"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 512), [
                                      [_vShow, !_ctx.options.isEdit]
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_37, [
                                    _withDirectives(_createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_38, [
                                        _createVNode(_component_el_form_item, {
                                          class: "m-0",
                                          prop: 
                                      'relation_items.' +
                                      index +
                                      '.unit_net_amount'
                                    
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_39, [
                                              _withDirectives(_createVNode(_component_el_input_number, {
                                                class: "w-90px size-sm text-end",
                                                modelValue: item.unit_net_amount,
                                                "onUpdate:modelValue": ($event: any) => ((item.unit_net_amount) = $event),
                                                precision: 2,
                                                step: 0.01,
                                                min: 0,
                                                controls: false,
                                                onChange: ($event: any) => (
                                          _ctx.priceChange($event, index, 'net')
                                        )
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "onChange"]), [
                                                [_vShow, !_ctx.options.isTaxCount]
                                              ]),
                                              _withDirectives(_createVNode(_component_el_input_number, {
                                                class: "w-90px size-sm text-end",
                                                modelValue: item.unit_gross_amount,
                                                "onUpdate:modelValue": ($event: any) => ((item.unit_gross_amount) = $event),
                                                precision: 2,
                                                step: 0.01,
                                                min: 0,
                                                controls: false,
                                                onChange: ($event: any) => (
                                          _ctx.priceChange($event, index, 'gross')
                                        )
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "onChange"]), [
                                                [_vShow, _ctx.options.isTaxCount]
                                              ]),
                                              _createElementVNode("div", _hoisted_40, _toDisplayString(item.currency == "CNY" ? "￥" : "€"), 1)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["prop"])
                                      ])
                                    ], 512), [
                                      [_vShow, _ctx.options.isEdit]
                                    ]),
                                    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.isDoubleSale
                                    ? _ctx.$currency.currency(
                                        item.unit_net_amount,
                                        2,
                                        ",",
                                        ".",
                                        "€ "
                                      )
                                    : _ctx.$currency.currency(
                                        _ctx.options.isTaxCount
                                          ? item.unit_gross_amount
                                          : item.unit_net_amount,
                                        2,
                                        ",",
                                        ".",
                                        "€ "
                                      )), 513), [
                                      [_vShow, !_ctx.options.isEdit]
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    (!_ctx.isDoubleSale && !_ctx.isAuditView)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                          _withDirectives(_createElementVNode("div", null, [
                                            _createVNode(_component_el_form_item, {
                                              class: "m-0",
                                              prop: 
                                      'relation_items.' + index + '.discount'
                                    
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_42, [
                                                  _createVNode(_component_el_input_number, {
                                                    class: "w-60px size-sm text-end",
                                                    modelValue: item.discount,
                                                    "onUpdate:modelValue": ($event: any) => ((item.discount) = $event),
                                                    precision: 2,
                                                    step: 0.01,
                                                    min: 0,
                                                    controls: false
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "step"]),
                                                  _createElementVNode("div", _hoisted_43, [
                                                    _createVNode(_component_el_select, {
                                                      class: "w-50px size-sm",
                                                      modelValue: item.discount_type,
                                                      "onUpdate:modelValue": ($event: any) => ((item.discount_type) = $event),
                                                      placeholder: _ctx.t('common.plsSelect')
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.discount, (row) => {
                                                          return (_openBlock(), _createBlock(_component_el_option, {
                                                            key: row.value,
                                                            label: row.label,
                                                            value: row.value
                                                          }, null, 8, ["label", "value"]))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                                  ])
                                                ])
                                              ]),
                                              _: 2
                                            }, 1032, ["prop"])
                                          ], 512), [
                                            [_vShow, _ctx.options.isEdit]
                                          ]),
                                          _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                      item.discount,
                                      2,
                                      ",",
                                      ".",
                                      ""
                                    )) + _toDisplayString(item.discount_type === _ctx.CurrencyType.Amount
                                      ? "€"
                                      : "%"), 513), [
                                            [_vShow, !_ctx.options.isEdit]
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", _hoisted_44, [
                                    _withDirectives(_createElementVNode("div", null, [
                                      _createVNode(_component_el_form_item, {
                                        class: "m-0",
                                        prop: 'relation_items.' + index + '.tax'
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            class: _normalizeClass(["w-70px size-sm", {
                                      'border-danger rounded border':
                                        _ctx.formData.__show.tax_rates.indexOf(
                                          item.tax_rate
                                        ) === -1 && item.tax_rate !== 0,
                                    }]),
                                            modelValue: item.tax_rate,
                                            "onUpdate:modelValue": ($event: any) => ((item.tax_rate) = $event),
                                            placeholder: _ctx.t('common.plsSelect')
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_option, {
                                                label: '0%',
                                                value: 0
                                              }),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.__show.tax_rates, (row) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: row,
                                                  label: row + '%',
                                                  value: row
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["class", "modelValue", "onUpdate:modelValue", "placeholder"])
                                        ]),
                                        _: 2
                                      }, 1032, ["prop"])
                                    ], 512), [
                                      [_vShow, _ctx.options.isEdit]
                                    ]),
                                    _withDirectives(_createElementVNode("div", null, _toDisplayString(item.tax_rate + "%"), 513), [
                                      [_vShow, !_ctx.options.isEdit]
                                    ])
                                  ]),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["text-end text-nowrap", {
                                'pe-0': !_ctx.options.isAdd,
                              }])
                                  }, _toDisplayString(_ctx.isDoubleSale
                                  ? _ctx.$currency.currency(
                                      item.total_gross_amount,
                                      2,
                                      ",",
                                      ".",
                                      "€ "
                                    )
                                  : _ctx.$currency.currency(
                                      _ctx.getOrderItemAmountTotal(
                                        _ctx.options.isAdd
                                          ? item.request_qty
                                          : item.confirmed_qty,
                                        _ctx.getNetPrice(item),
                                        item.discount,
                                        item.discount_type,
                                        item.tax_rate,
                                        _ctx.isGrossCalculation
                                      ),
                                      2,
                                      ",",
                                      ".",
                                      "€ "
                                    )), 3),
                                  _withDirectives(_createElementVNode("td", _hoisted_45, [
                                    (_ctx.options.isAdd)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "btn btn-sm btn-icon btn-light-danger",
                                          onClick: ($event: any) => (_ctx.removeItem(index))
                                        }, [
                                          _createElementVNode("span", _hoisted_47, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                                          ])
                                        ], 8, _hoisted_46))
                                      : _createCommentVNode("", true),
                                    (_ctx.isCanPrint)
                                      ? (_openBlock(), _createBlock(_component_el_popover, {
                                          key: 1,
                                          placement: "top",
                                          width: "auto",
                                          trigger: "hover"
                                        }, {
                                          reference: _withCtx(() => [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm max-sm-hidden",
                                              onClick: ($event: any) => (_ctx.getPrintedSheet(item))
                                            }, [
                                              _createElementVNode("span", _hoisted_49, [
                                                _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/print.svg" })
                                              ])
                                            ], 8, _hoisted_48)
                                          ]),
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t("common.print")) + " ", 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ], 512), [
                                    [_vShow, _ctx.options.isAdd || _ctx.isCanPrint]
                                  ])
                                ], 2),
                                (_ctx.isShowItemDescription(item))
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                                      _createElementVNode("td", _hoisted_51, [
                                        (_ctx.options.isEdit)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                              _createElementVNode("span", null, [
                                                _createElementVNode("span", {
                                                  class: "break-all cursor-pointer",
                                                  "data-bs-toggle": "modal",
                                                  "data-bs-target": "#modal_update_product_not_date",
                                                  onClick: ($event: any) => (_ctx.handleNotDate(item, index))
                                                }, [
                                                  (
                                        item.inventory_note ||
                                        item.not_available_until
                                      )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                                                        (item.not_available_until)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.t(
                                            "orderRequest.notAvailableUntilDate",
                                            [
                                              _ctx.customFormatDate(
                                                item.not_available_until,
                                                "DD.MM.YYYY"
                                              ),
                                            ]
                                          )), 1))
                                                          : _createCommentVNode("", true),
                                                        (
                                          item.inventory_note &&
                                          item.inventory_note
                                        )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_56))
                                                          : _createCommentVNode("", true),
                                                        (item.inventory_note)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(item.inventory_note), 1))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.t("orderRequest.addInventoryNote")), 1))
                                                ], 8, _hoisted_53)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _createElementVNode("span", {
                                                  class: "break-all cursor-pointer",
                                                  "data-bs-toggle": "modal",
                                                  "data-bs-target": "#modal_update_product_notes",
                                                  onClick: ($event: any) => (
                                      _ctx.handleNotes(item.overall_notes, index)
                                    )
                                                }, _toDisplayString(item.overall_notes
                                        ? item.overall_notes
                                        : _ctx.t("orderRequest.addDescription")), 9, _hoisted_59)
                                              ])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                              (item.not_available_until)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                    (
                                      item.inventory_note ||
                                      item.not_available_until
                                    )
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                                                          (item.not_available_until)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(_ctx.t(
                                          "orderRequest.notAvailableUntilDate",
                                          [
                                            _ctx.customFormatDate(
                                              item.not_available_until
                                            ),
                                          ]
                                        )), 1))
                                                            : _createCommentVNode("", true),
                                                          (
                                        item.inventory_note &&
                                        item.inventory_note
                                      )
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_64))
                                                            : _createCommentVNode("", true),
                                                          (item.inventory_note)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(item.inventory_note), 1))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (item.overall_notes)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(item.overall_notes), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                colspan: !_ctx.options.isAdd && _ctx.options.isEdit ? 4 : 3
                              }, [
                                _withDirectives(_createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_68, [
                                    _createElementVNode("div", _hoisted_69, [
                                      _createElementVNode("div", _hoisted_70, [
                                        _createElementVNode("div", _hoisted_71, [
                                          _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.t("orderRequest.reference")) + "#", 1),
                                          _createVNode(_component_el_form_item, {
                                            prop: "reference",
                                            class: "max-sm-w-100"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_input, {
                                                class: "mw-300px max-sm-mw-380px",
                                                modelValue: _ctx.formData.reference,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.reference) = $event)),
                                                type: "text",
                                                placeholder: _ctx.t('common.plsEnter'),
                                                clearable: ""
                                              }, null, 8, ["modelValue", "placeholder"])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_73, [
                                        _createElementVNode("div", _hoisted_74, [
                                          _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.t("orderRequest.orderNotes")), 1),
                                          _createVNode(_component_el_form_item, {
                                            prop: "overall_notes",
                                            class: "max-sm-w-100"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_input, {
                                                class: "mw-300px max-sm-mw-380px",
                                                modelValue: _ctx.formData.overall_notes,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.overall_notes) = $event)),
                                                type: "textarea",
                                                placeholder: _ctx.t('common.plsEnter'),
                                                clearable: ""
                                              }, null, 8, ["modelValue", "placeholder"])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 512), [
                                  [_vShow, _ctx.options.isEdit]
                                ]),
                                _withDirectives(_createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("div", _hoisted_77, [
                                      _withDirectives(_createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("div", _hoisted_79, [
                                          _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.t("orderRequest.reference")) + ":", 1),
                                          _createElementVNode("div", _hoisted_81, [
                                            _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.formData.reference), 1)
                                          ])
                                        ])
                                      ], 512), [
                                        [_vShow, !_ctx.isDoubleSale]
                                      ]),
                                      _createElementVNode("div", _hoisted_83, [
                                        _createElementVNode("div", _hoisted_84, [
                                          _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.t("orderRequest.orderNotes")) + ":", 1),
                                          _createElementVNode("div", _hoisted_86, [
                                            _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.formData.overall_notes), 1)
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 512), [
                                  [_vShow, !_ctx.options.isEdit]
                                ])
                              ], 8, _hoisted_67),
                              _createElementVNode("td", _hoisted_88, [
                                _createElementVNode("div", _hoisted_89, [
                                  _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.t("orderRequest.subtotalExclTax")) + ": ", 1),
                                  (_ctx.formData.shipping_tax_rate !== 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(_ctx.t("orderRequest.shippingCharge")) + ": ", 1))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVatArr, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_ctx.t("order.taxPercent2", [item.tax_percent])), 1))
                                  }), 128)),
                                  (_ctx.formData.shipping_tax_rate !== 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(_ctx.t("orderRequest.shippingCharge")) + ": ", 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.t("orderRequest.total")) + ": ", 1)
                                ])
                              ]),
                              _hoisted_94,
                              _createElementVNode("td", _hoisted_95, [
                                _createElementVNode("div", _hoisted_96, [
                                  _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.isDoubleSale
                                    ? _ctx.$currency.currency(
                                        _ctx.dsTotalNetAmount,
                                        2,
                                        ",",
                                        ".",
                                        "€ "
                                      )
                                    : _ctx.$currency.currency(
                                        _ctx.getAmountSubTotal,
                                        2,
                                        ",",
                                        ".",
                                        "€ "
                                      )), 1),
                                  (_ctx.formData.shipping_tax_rate !== 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                                    _ctx.getOrderItemAmountTotal(
                                      1,
                                      Number(_ctx.formData.shipping_charges),
                                      0,
                                      _ctx.CurrencyType.Amount,
                                      _ctx.formData.shipping_tax_rate,
                                      false
                                    ) +
                                      _ctx.getOrderItemVatTotal(
                                        1,
                                        Number(_ctx.formData.shipping_charges),
                                        0,
                                        _ctx.CurrencyType.Amount,
                                        _ctx.formData.shipping_tax_rate,
                                        false
                                      ),
                                    2,
                                    ",",
                                    ".",
                                    "€ "
                                  )), 1),
                                        _withDirectives(_createElementVNode("span", _hoisted_99, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                        ], 512), [
                                          [_vShow, _ctx.options.isEdit]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVatArr, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                      (
                                    index === _ctx.getVatArr.length - 1 &&
                                    _ctx.isDoubleSale
                                  )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$currency.currency(
                                      _ctx.dsTotalGrossAmount - _ctx.dsTotalNetAmount,
                                      2,
                                      ",",
                                      ".",
                                      "€ "
                                    )), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$currency.currency(
                                      _ctx.getVatItemTotal(item.tax_percent),
                                      2,
                                      ",",
                                      ".",
                                      "€ "
                                    )), 1)
                                          ], 64))
                                    ]))
                                  }), 128)),
                                  (_ctx.formData.shipping_tax_rate !== 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.getOrderItemAmountTotal(
                                        1,
                                        Number(_ctx.formData.shipping_charges),
                                        0,
                                        _ctx.CurrencyType.Amount,
                                        _ctx.formData.shipping_tax_rate,
                                        false
                                      ) +
                                        _ctx.getOrderItemVatTotal(
                                          1,
                                          Number(_ctx.formData.shipping_charges),
                                          0,
                                          _ctx.CurrencyType.Amount,
                                          _ctx.formData.shipping_tax_rate,
                                          false
                                        ),
                                      2,
                                      ",",
                                      ".",
                                      "€ "
                                    )), 1),
                                        _withDirectives(_createElementVNode("span", _hoisted_101, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                        ], 512), [
                                          [_vShow, _ctx.options.isEdit]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.isDoubleSale
                                    ? _ctx.$currency.currency(
                                        _ctx.dsTotalGrossAmount,
                                        2,
                                        ",",
                                        ".",
                                        "€ "
                                      )
                                    : _ctx.$currency.currency(
                                        _ctx.getOrderItemsTotal,
                                        2,
                                        ",",
                                        ".",
                                        "€ "
                                      )), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane blockui", {
                      active: _ctx.options.tabIndex === 1,
                    }])
                      }, [
                        _createElementVNode("table", _hoisted_103, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_104, [
                              _createElementVNode("th", _hoisted_105, _toDisplayString(_ctx.t("order.product")), 1),
                              _createElementVNode("th", _hoisted_106, _toDisplayString(_ctx.t("order.sku")), 1),
                              _createElementVNode("th", _hoisted_107, _toDisplayString(_ctx.t("orderRequest.qtyConfirmed")), 1),
                              _createElementVNode("th", _hoisted_108, _toDisplayString(_ctx.t("orderRequest.qtyShipped")), 1),
                              _createElementVNode("th", _hoisted_109, _toDisplayString(_ctx.t("orderRequest.qtyReceived")), 1),
                              _createElementVNode("th", _hoisted_110, _toDisplayString(_ctx.t("orderRequest.qtyInspected")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", _hoisted_111, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.relation_items, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createVNode(_component_common_product, {
                                  gallery: [
                              {
                                id: 0,
                                origin_url: item.__show.product_gallery,
                              },
                            ],
                                  brand_id: item.brand_name,
                                  brand_article_no: item.article_no,
                                  product_identifier_id: '0',
                                  source_link: '',
                                  name: item.__show.product_name,
                                  name_en: item.__show.product_name,
                                  color: item.color,
                                  size: item.size
                                }, null, 8, ["gallery", "brand_id", "brand_article_no", "name", "name_en", "color", "size"]),
                                _createElementVNode("td", _hoisted_112, _toDisplayString(item.confirmed_qty), 1),
                                _createElementVNode("td", _hoisted_113, _toDisplayString(item.shipped_qty), 1),
                                _createElementVNode("td", _hoisted_114, _toDisplayString(item.__show.received), 1),
                                _createElementVNode("td", _hoisted_115, _toDisplayString(item.__show.inspected), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ], 2)
                    ])
                  ]),
                  _createVNode(_component_window_resize, null, {
                    sm: _withCtx(() => [
                      (_ctx.options.isEdit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                            _createVNode(_component_permission_common, { role: { auth: ['delete'] } }, {
                              default: _withCtx(() => [
                                (
                          _ctx.formData.order_progress ===
                            _ctx.OrderRequestProgress.Draft && !_ctx.options.isDraft
                        )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-light w-100",
                                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeDraft && _ctx.removeDraft(...args)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_117,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_118, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.delete")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_permission_common, { role: { auth: ['add', 'update'] } }, {
                              default: _withCtx(() => [
                                (_ctx.options.isAdd)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-light w-100",
                                      disabled: 
                          _ctx.loading ||
                          _ctx.isDisabledSubmit ||
                          _ctx.formData.merchant === 0 ||
                          _ctx.formData.invoice_address === 0
                        ,
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submit(1)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_120,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_121, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.submit")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ], 8, _hoisted_119))
                                  : _createCommentVNode("", true),
                                (_ctx.options.isAdd)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "btn btn-primary w-100",
                                      disabled: 
                          _ctx.loading ||
                          _ctx.isDisabledSubmit ||
                          _ctx.formData.merchant === 0 ||
                          _ctx.formData.invoice_address === 0
                        ,
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.submit(0)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_123,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_124, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.saveDraft")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ], 8, _hoisted_122))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                              default: _withCtx(() => [
                                (
                          _ctx.formData.order_progress === _ctx.OrderRequestProgress.New
                        )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-light w-100",
                                      disabled: _ctx.loading,
                                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.canceledOrderRequest && _ctx.canceledOrderRequest(...args)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_126,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_127, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.canceled")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ], 8, _hoisted_125))
                                  : _createCommentVNode("", true),
                                (
                          _ctx.formData.order_progress >
                            _ctx.OrderRequestProgress.Draft &&
                          _ctx.formData.order_progress <
                            _ctx.OrderRequestProgress.Confirmed
                        )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "btn btn-light w-100",
                                      disabled: _ctx.loading || _ctx.isDisabledSubmit,
                                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.confirmedOrderRequest && _ctx.confirmedOrderRequest(...args)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_129,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_130, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.confirm")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ], 8, _hoisted_128))
                                  : _createCommentVNode("", true),
                                (!_ctx.options.isAdd)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "btn btn-primary w-100",
                                      disabled: _ctx.loading || _ctx.isDisabledSubmit,
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.submit(0)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_132,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_133, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.save")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ], 8, _hoisted_131))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    lg: _withCtx(() => [
                      (_ctx.options.isEdit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                            _createVNode(_component_permission_common, { role: { auth: ['delete'] } }, {
                              default: _withCtx(() => [
                                (
                          _ctx.formData.order_progress ===
                            _ctx.OrderRequestProgress.Draft && !_ctx.options.isDraft
                        )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-light",
                                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.removeDraft && _ctx.removeDraft(...args)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_135,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_136, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.delete")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_permission_common, { role: { auth: ['add', 'update'] } }, {
                              default: _withCtx(() => [
                                (_ctx.options.isAdd)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-light",
                                      disabled: 
                          _ctx.loading ||
                          _ctx.isDisabledSubmit ||
                          _ctx.formData.merchant === 0 ||
                          _ctx.formData.invoice_address === 0
                        ,
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.submit(1)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_138,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_139, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.submit")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ], 8, _hoisted_137))
                                  : _createCommentVNode("", true),
                                (_ctx.options.isAdd)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "btn btn-primary",
                                      disabled: 
                          _ctx.loading ||
                          _ctx.isDisabledSubmit ||
                          _ctx.formData.merchant === 0 ||
                          _ctx.formData.invoice_address === 0
                        ,
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.submit(0)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_141,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_142, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.saveDraft")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ], 8, _hoisted_140))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                              default: _withCtx(() => [
                                (
                          _ctx.formData.order_progress === _ctx.OrderRequestProgress.New
                        )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-light",
                                      disabled: _ctx.loading,
                                      onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.canceledOrderRequest && _ctx.canceledOrderRequest(...args)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_144,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_145, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.canceled")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ], 8, _hoisted_143))
                                  : _createCommentVNode("", true),
                                (
                          _ctx.formData.order_progress >
                            _ctx.OrderRequestProgress.Draft &&
                          _ctx.formData.order_progress <
                            _ctx.OrderRequestProgress.Confirmed
                        )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "btn btn-light",
                                      disabled: _ctx.loading || _ctx.isDisabledSubmit,
                                      onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.confirmedOrderRequest && _ctx.confirmedOrderRequest(...args)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_147,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_148, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.confirm")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ], 8, _hoisted_146))
                                  : _createCommentVNode("", true),
                                (!_ctx.options.isAdd)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "btn btn-primary",
                                      disabled: _ctx.loading || _ctx.isDisabledSubmit,
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.submit(0)))
                                    }, [
                                      _withDirectives(_createElementVNode("span", null, [
                                        _hoisted_150,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                                      ], 512), [
                                        [_vShow, _ctx.loading]
                                      ]),
                                      _withDirectives(_createElementVNode("span", null, [
                                        _createElementVNode("span", _hoisted_151, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("common.save")), 1)
                                      ], 512), [
                                        [_vShow, !_ctx.loading]
                                      ])
                                    ], 8, _hoisted_149))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ], 2),
              _withDirectives(_createElementVNode("div", _hoisted_152, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_153, [
                  _createElementVNode("div", _hoisted_154, [
                    _createElementVNode("div", _hoisted_155, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRequest.shipmentTracking")), 1),
                      (_ctx.OrderRequestTrackingShipmentTracking)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_156, _toDisplayString(_ctx.OrderRequestLen) + " " + _toDisplayString(_ctx.t("orderRequest.trackingBatches")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_157, [
                      _createElementVNode("button", {
                        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.changeShipmentShow && _ctx.changeShipmentShow(...args))),
                        type: "button",
                        class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                      }, [
                        _createElementVNode("span", _hoisted_158, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen024.svg" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_159, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OrderRequestTrackingShipmentTracking, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "m-0 mb-5"
                      }, [
                        _createElementVNode("div", _hoisted_160, [
                          (0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                                _createElementVNode("span", _hoisted_162, [
                                  (
                              _ctx.getServiceProviderMap(item.service_provider_id)
                            )
                                    ? (_openBlock(), _createBlock(_component_el_image, {
                                        key: 0,
                                        class: "d-flex",
                                        fit: "contain",
                                        title: item.courier,
                                        src: 
                              _ctx.getServiceProviderMap(item.service_provider_id)
                            
                                      }, null, 8, ["title", "src"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_163, [
                            _createElementVNode("div", _hoisted_164, [
                              _createElementVNode("div", _hoisted_165, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.trackingBatch")) + " " + _toDisplayString(index + 1) + " / " + _toDisplayString(item.courier), 1)
                              ]),
                              _createElementVNode("div", _hoisted_166, _toDisplayString(item.tracking_no), 1)
                            ]),
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge badge-lg fw-bold my-2", _ctx.getShipmentStatusMap(item.status)])
                            }, _toDisplayString(item.status_show), 3)
                          ])
                        ]),
                        _withDirectives(_createElementVNode("div", null, [
                          _hoisted_167,
                          _createElementVNode("div", _hoisted_168, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.skus, (row, rowIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "fw-bold active symbol p-0",
                                key: rowIndex
                              }, [
                                _createElementVNode("span", _hoisted_169, [
                                  (row.product_gallery.length > 0)
                                    ? (_openBlock(), _createBlock(_component_el_carousel, {
                                        key: 0,
                                        class: "w-100",
                                        "indicator-position": "none",
                                        autoplay: false,
                                        arrow: "never",
                                        height: "50px"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.product_gallery, (gallery, galleryIndex) => {
                                            return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                              key: galleryIndex,
                                              class: "d-flex justify-content-center align-items-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_image, {
                                                  class: "w-100 h-100 cursor-pointer",
                                                  fit: "contain",
                                                  title: item.courier,
                                                  src: 
                                    gallery.origin_url +
                                    '?x-oss-process=image/resize,l_200'
                                  ,
                                                  onClick: ($event: any) => (
                                    _ctx.previewTrackingImages(
                                      row.product_gallery,
                                      galleryIndex
                                    )
                                  )
                                                }, null, 8, ["title", "src", "onClick"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", _hoisted_170, _toDisplayString(row.qty), 1)
                              ]))
                            }), 128))
                          ]),
                          _hoisted_171,
                          _createElementVNode("div", _hoisted_172, [
                            _createElementVNode("div", _hoisted_173, [
                              _hoisted_174,
                              _createElementVNode("div", _hoisted_175, [
                                _createElementVNode("span", _hoisted_176, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen015.svg" })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_177, [
                                _createElementVNode("span", _hoisted_178, _toDisplayString(item.delivery_from), 1),
                                _createElementVNode("span", _hoisted_179, _toDisplayString(_ctx.customFormatDate(item.delivery_date)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_180, [
                              _hoisted_181,
                              _createElementVNode("div", _hoisted_182, [
                                _createElementVNode("span", _hoisted_183, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen018.svg" })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_184, [
                                _createElementVNode("span", _hoisted_185, _toDisplayString(item.destination), 1),
                                _createElementVNode("span", _hoisted_186, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass({ 'text-gray-400': item.status != 40 })
                                  }, _toDisplayString(_ctx.customFormatDate(item.received_date)), 3)
                                ])
                              ])
                            ])
                          ]),
                          (index + 1 < _ctx.OrderRequestLen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_187))
                            : _createCommentVNode("", true)
                        ], 512), [
                          [_vShow, _ctx.options.shipmentShowDetails]
                        ])
                      ]))
                    }), 128))
                  ])
                ])), [
                  [_directive_loading, _ctx.options.shipmentLoading]
                ])
              ], 512), [
                [_vShow, !_ctx.options.isEdit]
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"]),
    _createVNode(_component_confirm_product_modal, {
      ref: "confirmProductRef",
      form: _ctx.formData,
      getNetPrice: _ctx.getNetPrice,
      getItemAmountTotal: _ctx.getOrderItemAmountTotal,
      getItemVatTotal: _ctx.getOrderItemVatTotal,
      isTaxCount: _ctx.options.isTaxCount,
      onUpdateList: _ctx.updateDetail
    }, null, 8, ["form", "getNetPrice", "getItemAmountTotal", "getItemVatTotal", "isTaxCount", "onUpdateList"]),
    _createVNode(_component_update_shipping_fee, {
      amount: _ctx.formData.shipping_charges,
      tax: _ctx.formData.shipping_tax_rate,
      taxArr: _ctx.formData.__show.tax_rates,
      onUpdateList: _ctx.updateShippingFee
    }, null, 8, ["amount", "tax", "taxArr", "onUpdateList"]),
    _createVNode(_component_UpdateProduct, {
      merchantId: Number(_ctx.formData.merchant),
      channelId: Number(_ctx.formData.channel),
      merchantChannl: _ctx.formData.__show.channel,
      onUpdateList: _ctx.updateProduct
    }, null, 8, ["merchantId", "channelId", "merchantChannl", "onUpdateList"]),
    _createVNode(_component_UpdateProductNotes, {
      notes: _ctx.options.notes,
      onUpdateList: _ctx.updateProductNotes
    }, null, 8, ["notes", "onUpdateList"]),
    _createVNode(_component_update_product_not_date, {
      id: String(_ctx.options.updateNotDateId),
      notes: _ctx.options.notes,
      date: _ctx.options.date,
      onUpdateList: _ctx.updateProductNotDate
    }, null, 8, ["id", "notes", "date", "onUpdateList"]),
    _createVNode(_component_print_preview, {
      ref: "printPreviewRef",
      postUrl: _ctx.options.postUrl
    }, null, 8, ["postUrl"])
  ], 64))
}